/**
 * Eager bit of the cups for the map rail: a trophy cup over a map pin (inline SVG in the
 * overlay's toon icon style until the atlas has an `ico_cup`: sharedRequests).
 */
import type { JSX } from 'preact';

const INK = '#4a2c2a';

export function CupMark({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M9 4h14v7a7 7 0 0 1-14 0z" fill="#ffc845" stroke={INK} stroke-width="2" stroke-linejoin="round" />
      <path d="M9 6H5.5a4 4 0 0 0 4.4 6M23 6h3.5a4 4 0 0 1-4.4 6" fill="none" stroke={INK} stroke-width="1.8" stroke-linecap="round" />
      <path d="M14.5 18h3v3h-3z" fill="#d99a1c" stroke={INK} stroke-width="1.6" />
      <path d="M16 21c-4.4 0-7 2.4-7 5 0 1.5 7 4 7 4s7-2.5 7-4c0-2.6-2.6-5-7-5z" fill="#2ec4b6" stroke={INK} stroke-width="1.8" stroke-linejoin="round" />
      <circle cx="16" cy="25.4" r="1.8" fill="#fff8ec" stroke={INK} stroke-width="1.2" />
      <path d="M13 7.5c.6-1.4 1.6-2 3-2.2" fill="none" stroke="#fff4b0" stroke-width="1.6" stroke-linecap="round" />
    </svg>
  );
}
